export default __webpack_public_path__ + "static/media/adobexd.9c224a9f.png";